import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Form, Input, Select } from 'antd';
import _ from 'lodash';
import settings from 'settings';
import { getKey } from 'library/helpers';
import { list } from 'actions';
import REDUCER_KEY from 'reducers/reducer.keys';
import ExtendedSelect from 'components/extendedSelect/extended-select';
import { FormWrapper } from 'components/Page';

const FormItem = Form.Item;
const { Option } = Select;

const mapStateToProps = state => ({
  travellers: state.api.peopleData.data.results,
  inFlight: state.api.peopleData.inFlight
});

const mapDispatchToProps = dispatch => ({
  loadUsers(searchText) {
    const page = 0;
    const pageSize = settings.APP_CONFIG.dropListSize;
    const sorted = [{
      id: 'last_name',
      desc: false
    }];
    const filters = [];

    if (!_.isEmpty(searchText)) {
      filters.push({
        id: 'name',
        value: searchText
      });
    }
    filters.push({
      id: 'active',
      value: true
    });

    return dispatch(list(REDUCER_KEY.peopleData.key, {
      page,
      pageSize,
      filters,
      sorted
    }));
  }
});

const mapPropsToFields = (props) => {
  const { dataSource } = props;
  const {
    reference_number, user, travel_type
  } = dataSource;

  const traveller = user && !user.key
    ? {
      key: user.id,
      label: `${user.last_name}, ${user.first_name}`
    }
    : user;

  return {
    reference_number: Form.createFormField({ value: reference_number }),
    user: Form.createFormField({ value: traveller }),
    travel_type: Form.createFormField({ value: travel_type })
  };
};

const onFieldsChange = (props, fields) => {
  const { onFieldsChange: dispatchOnFieldsChange } = props;
  if (dispatchOnFieldsChange) {
    dispatchOnFieldsChange(fields);
  }
};

const onValuesChange = (props, values) => {
  const { onValuesChange: dispatchOnValuesChange } = props;
  if (dispatchOnValuesChange) {
    dispatchOnValuesChange(values);
  }
};

const FormInput = ({
  canAdmin, dataSource, inFlight, inputFormItemLayout, form, loadUsers, travellers
}) => {
  const { getFieldDecorator } = form;
  const {
    reference_number, user, travel_type
  } = dataSource;
  const traveller = user
    ? {
      id: user.id,
      name: `${user.last_name}, ${user.first_name}`
    }
    : undefined;
  const readonly = !canAdmin;
  return (
    <Form>
      <FormItem {...inputFormItemLayout} label="Itinerary Reference">
        {getFieldDecorator('reference_number', {
          initialValue: reference_number
        })(<Input disabled={readonly} />)}
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Traveller">
        {getFieldDecorator('user', {
          initialValue: traveller,
          rules: [{
            required: true,
            message: 'Please select the Traveller.'
          }]
        })(
          <ExtendedSelect
            fetching={inFlight}
            placeholder="Select Traveller"
            dataSource={travellers}
            optionKey={getKey}
            optionLabel={item => `${item.last_name}, ${item.first_name}`}
            disabled={readonly}
            onSearch={loadUsers}
            onFocus={loadUsers}
          />
        )}
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Travel Type">
        {getFieldDecorator('travel_type', {
          initialValue: travel_type,
          rules: [
            {
              required: true,
              message: 'Please select the Travel Type.'
            }
          ]
        })(
          <Select
            showSearch
            placeholder="Select Travel Type"
            optionFilterProp="children"
            filterOption={(input, option) => option.props.children
              .toLowerCase()
              .indexOf(input.toLowerCase()) >= 0}
            disabled={readonly}
          >
            <Option key="In" value="In">
              In
            </Option>
            <Option key="Out" value="Out">
              Out
            </Option>
            <Option key="Intra" value="Intra">
              Intra
            </Option>
          </Select>
        )}
      </FormItem>
    </Form>
  );
};

FormInput.propTypes = {
  canAdmin: PropTypes.bool,
  inFlight: PropTypes.bool,
  dataSource: PropTypes.object,
  form: PropTypes.object,
  inputFormItemLayout: PropTypes.object,
  onFieldsChange: PropTypes.func,
  onValuesChange: PropTypes.func,
  loadUsers: PropTypes.func,
  travellers: PropTypes.array
};

FormInput.defaultProps = {
  canAdmin: false,
  inFlight: false,
  dataSource: {},
  form: {},
  inputFormItemLayout: {},
  onFieldsChange() {
  },
  onValuesChange() {
  },
  loadUsers() {
  },
  travellers: []
};

const ConnectedFormInput = connect(mapStateToProps, mapDispatchToProps)(FormInput);

const ItineraryFormInput = FormWrapper(Form.create({
  mapPropsToFields,
  onFieldsChange,
  onValuesChange
})(ConnectedFormInput));

export default ItineraryFormInput;
